module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/usuarios/listagem-usuario/listagem-usuario.component.scss
// module id = ./src/app/routes/usuarios/listagem-usuario/listagem-usuario.component.scss
// module chunks = main